/* ==========================================================================
   InputPanel > Client > ui
   ========================================================================== */
const { actions, types } = require('../store/actions');
const configuration = require('../config');

function startUi(instance) {
    const inst = instance;

    /* Extends actions */
    inst.actions = {
        ...inst.actions,
        disable: () => inst.store.dispatch(actions.disable()),
        display: () => inst.store.dispatch(actions.display()),
        enable: () => inst.store.dispatch(actions.enable()),
        hide: () => inst.store.dispatch(actions.hide())
    };

    /* Extends reactions */
    inst.reactions = {
        ...inst.reactions,
        display: inst.store.subscribe((state, action) => {
            if (action.type !== types.DISPLAY) return;

            inst.element.classList.remove(configuration().css.hidden);
        }),
        hide: inst.store.subscribe((state, action) => {
            if (action.type !== types.HIDE) return;

            inst.element.classList.add(configuration().css.hidden);
        }),
        enable: inst.store.subscribe((state, action) => {
            if (action.type !== types.ENABLE) return;

            if (inst.input) inst.input.actions.enable();
        }),
        disable: inst.store.subscribe((state, action) => {
            if (action.type !== types.DISABLE) return;
            if (inst.input) inst.input.actions.disable();
        })
    };
}

module.exports = {
    startUi
};
